module.exports = __webpack_public_path__ + "media/images/icon-favorite-active-b0e89f705ffda64fc5e92c7596a25e1c.svg";